import { useQuery } from '@tanstack/react-query';

import { getCrews } from '../apis';
import { teamKeys } from './teamKeys';

export const useCrews = () =>
  useQuery({
    queryKey: teamKeys.crews,
    queryFn: getCrews,
    select: (data) => data.crews,
  });
